import { TExamStepIndustryOutputDto } from "@/api/services/main/exam-steps/dtos/get-exam-step-list.dto";
import { IndustryNameLabel } from "@/components/elements/IndustryNameLabel";
import { InnerBox } from "@/components/elements/InnerBox";
import { AppRoutes } from "@/routes/config";
import { button, text } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { dayjs } from "@/utils/dayjs";
import { getDynamicRoute } from "@/utils/url";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const calcMonthLeftToExam = (examMonth: string): number => {
  const exam = dayjs(examMonth, "YYYY/MM");
  const now = dayjs();
  return exam.diff(now.startOf("month"), "month");
};

type TExamStepProgressItemProps = {
  industryNames: string[];
  industry: TExamStepIndustryOutputDto;
};

export const ExamStepProgressItem: FC<TExamStepProgressItemProps> = ({ industry, industryNames }) => {
  const navigate = useNavigate();
  const hasUsers = industry.learnerCount > 0;
  const monthLeftToExam = useMemo(() => (industry.examMonth ? Math.max(calcMonthLeftToExam(industry.examMonth), 0) : null), [industry.examMonth]);

  const handleClick = () => {
    navigate(getDynamicRoute(AppRoutes.examStepDetail, { industryId: industry.id }));
  };

  return (
    <InnerBox
      padding="0"
      showDivider={false}
      sx={{
        cursor: "pointer",
        overflow: "hidden",
      }}
      onClick={handleClick}
    >
      <Stack direction="row" alignItems="center">
        <IndustryNameLabel name={industry.name} allNames={industryNames} />
        <Stack direction="row" alignItems="center" justifyContent="space-between" p={spacing.sm} flex={1}>
          <Stack direction="row" gap={spacing.xs} alignItems="center" flex={1}>
            {hasUsers ? (
              <Typography component="p" variant="body14" color={text.secondary}>
                受験手続の管理対象者数:{" "}
                <Typography variant="body14Semi" color={text.primary}>
                  {industry.learnerCount}名
                </Typography>
              </Typography>
            ) : (
              <Typography component="p" variant="body14" color={text.secondary}>
                現在受験手続の管理対象者の登録なし
              </Typography>
            )}
            {hasUsers && industry.examMonth && monthLeftToExam !== null && (
              <>
                <Stack sx={{ width: "1px", height: "14px", bgcolor: text.disable }} />
                <Typography component="p" variant="body14" color={text.secondary}>
                  次回試験:{" "}
                  <Typography variant="body14Semi" color={text.primary}>
                    {industry.examMonth}（あと約{" "}
                  </Typography>
                  <Typography variant="body14Semi" color={monthLeftToExam <= 1 ? button.danger : text.primary}>
                    {monthLeftToExam === 0 ? "今月" : `${monthLeftToExam}か月`}
                  </Typography>
                  <Typography variant="body14Semi" color={text.primary}>
                    ）
                  </Typography>
                </Typography>
              </>
            )}
          </Stack>
          <ChevronRightIcon sx={{ color: text.secondary }} />
        </Stack>
      </Stack>
    </InnerBox>
  );
};
